import { render, staticRenderFns } from "./IstihkakForm.vue?vue&type=template&id=1fb8e7c0"
import script from "./IstihkakForm.vue?vue&type=script&lang=ts"
export * from "./IstihkakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports